import React, {forwardRef, useImperativeHandle} from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

let Modal = ({title, onSubmit, onClose, children, submitBtn = "Submit", cancelBtn = "Cancel"}, ref) => {
    const [open, setOpen] = React.useState(false);
    const [scroll, setScroll] = React.useState('paper');

    const handleClickOpen = (scrollType) => {
        setOpen(true);
        setScroll(scrollType);
    };

    const handleClose = () => {
        setOpen(false);
        onClose();
    };

    const handleSubmit = () => {
        onSubmit();
    };

    useImperativeHandle(ref, () => ({
        open: () => {
            handleClickOpen('paper')
        },
        close: () => {
            handleClose()
        }
    }));

    const descriptionElementRef = React.useRef(null);
    React.useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                className="__min-width_sm"
            >
                <DialogTitle id="scroll-dialog-title">{title}</DialogTitle>
                <DialogContent dividers={scroll === 'paper'}>
                    { children }
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>{cancelBtn}</Button>
                    <Button onClick={handleSubmit}>{submitBtn}</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default forwardRef(Modal);